import { z } from 'zod';
import { esquemaId, esquemaMotivo } from './comunes.js';
/**
 * Gastroenterologia (F6.3, SPEC-03, plan maestro §7.6).
 *
 * Un procedimiento endoscopico es un estudio con su informe original, y ademas
 * preparacion, consentimiento, sedacion, hallazgos, indicaciones y control. Las
 * muestras viven en la orden, con identificador y localizacion; el resultado de
 * patologia es otro estudio vinculado a UNA muestra por su identificador. Lo
 * pendiente se ve en la bandeja de trabajo hasta resolverse, no en un aviso que
 * se pierde. Nada de esto se publica a la paciente sin un reporte firmado.
 */
/** Procedimientos con preparacion, consentimiento y muestras con localizacion. */
export const PROCEDIMIENTOS_GASTRO = [
    'endoscopia-digestiva-alta',
    'colonoscopia',
];
/**
 * Tipos que solo se publican al portal con un reporte firmado y vigente
 * (§7.6: «revision y firma del reporte antes de publicarlo al paciente»).
 */
export const PUBLICAN_CON_REPORTE_FIRMADO = [
    ...PROCEDIMIENTOS_GASTRO,
    'patologia',
];
const texto = (maximo) => z.string().trim().max(maximo).default('');
export const esquemaGuardarProcedimiento = z
    .object({
    versionEsperada: z.number().int().min(0),
    /** Lo indicado a la paciente y como llego (la calidad la describe quien la valora). */
    preparacion: texto(1000),
    calidadPreparacion: texto(200),
    /** El consentimiento firmado: un documento de ESTA paciente, ya disponible. */
    consentimientoArchivoId: esquemaId,
    sedacion: texto(500),
    hallazgos: z.string().trim().min(2, 'Describa los hallazgos').max(5000),
    indicaciones: texto(2000),
    control: texto(500),
    /** Obligatorio si el resultado ya era definitivo: el cambio lo corrige. */
    motivo: esquemaMotivo.optional(),
})
    .strict();
//# sourceMappingURL=gastro.js.map